import { useWeb3React } from '@web3-react/core'
import { useContract } from './useContract'
import { ABI_LAUNCHPAD_POOL } from '../utils/abis'
import { useEffect, useState } from 'react'
import { isEqualString } from '../utils'

export enum DrawStatus {
  NotDraw, //未抽签
  DrawOut, // 未中签
  DrawIn, //中签
}

export default function useDrawStatus(poolAddress?: string) {
  const { account } = useWeb3React()
  const contract = useContract(poolAddress, ABI_LAUNCHPAD_POOL)
  const [drawStatus, setDrawStatus] = useState<DrawStatus>(DrawStatus.NotDraw)
  useEffect(() => {
    if (contract && account) {
      contract._drawUserStatus(account).then((res) => setDrawStatus(+res))
      const listener = (address: string, isIn: boolean) => {
        if (isEqualString(address, account)) {
          setDrawStatus(isIn ? DrawStatus.DrawIn : DrawStatus.DrawOut)
        }
      }
      contract.on('Draw', listener)
      return () => {
        contract.removeListener('Draw', listener)
      }
    }
  }, [contract, account, poolAddress])
  return drawStatus
}
